import React from "react";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import VerificationForm from "./payment/VerificationForm";
import PaymentForm from "./payment/PaymentForm";
import PublicHeader from "./components/header";
import "react-toastify/dist/ReactToastify.css";
import OtpForm from "./payment/OtpForm";
import RegistrationForm from "./registration/RegistrationForm";
import SubmitForm from "./registration/SubmitForm";
import EntranceExamResult from "./registration/EntranceExamResult";
import RegPay from "./registration/RegPay";
import "./style.css";
import PaymentFormRedirection from "./PaymentFormRedirection";

function App() {
  
 
  return (
    <Router>
      <div className="App">
        {/* Your existing content */}
        <Routes>
          <Route path="/" exact element={<VerificationForm />} />
          <Route path="/Verify" exact element={<OtpForm />} />
          <Route path="/Payonline" element={<PaymentForm />} />

          <Route path="/registration/form" element={<RegistrationForm />} />
          <Route path="/registration/submit" element={<SubmitForm />} />
          <Route path="/entranceExamResult" element={<EntranceExamResult />} />
          <Route path="/RegPay" element={<RegPay />} />
          <Route path="/Payment" element={<PaymentFormRedirection />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
